import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Stack,
} from '@mui/material';

/**
 * 공구 교체 기준 설정 - 기준(분)·경고 %(기본 80)·메모. [기준 설정] 아이콘을 누르면 열린다.
 * 저장은 호출한 쪽(EqpToolLifeTable)이 API를 치고 성공하면 닫는다.
 */
const EqpToolLifeDialog = ({ open, tool, submitting, onClose, onSubmit }) => {
  const [limitMin, setLimitMin] = useState('');
  const [warnPct, setWarnPct] = useState('80');
  const [rmk, setRmk] = useState('');

  useEffect(() => {
    if (!open) return;
    setLimitMin(tool?.limitMin != null ? String(tool.limitMin) : '');
    setWarnPct(tool?.warnPct != null ? String(tool.warnPct) : '80');
    setRmk(tool?.rmk || '');
  }, [open, tool]);

  const limitNum = Number(limitMin);
  const warnNum = Number(warnPct);
  const valid = limitMin !== '' && Number.isFinite(limitNum) && limitNum > 0
    && warnPct !== '' && Number.isFinite(warnNum) && warnNum > 0 && warnNum <= 100;

  const handleSubmit = () => {
    if (!valid) return;
    onSubmit({ limitMin: limitNum, warnPct: warnNum, rmk: rmk || null });
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle>T{tool?.toolNo} 교체 기준 설정</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <TextField
            label="기준(분)" type="number" value={limitMin} autoFocus
            onChange={(e) => setLimitMin(e.target.value)}
            helperText="누적 가공시간이 이 값을 넘으면 '기준 초과'로 표시됩니다."
            error={limitMin !== '' && !(Number.isFinite(limitNum) && limitNum > 0)}
            fullWidth
          />
          <TextField
            label="경고 %" type="number" value={warnPct}
            onChange={(e) => setWarnPct(e.target.value)}
            helperText="기준의 이 비율을 넘으면 '교체 임박'으로 표시됩니다(기본 80)."
            error={warnPct !== '' && !(Number.isFinite(warnNum) && warnNum > 0 && warnNum <= 100)}
            fullWidth
          />
          <TextField
            label="메모" value={rmk} multiline minRows={2}
            onChange={(e) => setRmk(e.target.value)}
            fullWidth
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>취소</Button>
        <Button onClick={handleSubmit} variant="contained" disabled={!valid || submitting}>저장</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EqpToolLifeDialog;
